/**
 * @generated SignedSource<<72528fd74f72f5e7d8b2887baed0c432>>
 * @relayHash fb7d2c4c3070d2398cb824d31c805be8
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fb7d2c4c3070d2398cb824d31c805be8

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type HtmlTag = "HTML";
export type ChangeCodeDetailsInput = {
  answer?: CodeAnswerInput | null;
  bodyItemId: string;
  clientMutationId?: string | null;
  initialCode?: CodeAnswerInput | null;
  initialFile?: CodeInitialFile | null;
  lang?: string | null;
  prompt?: HtmlInput | null;
  updateAnswer?: boolean | null;
  updateInitial?: boolean | null;
  updateLang?: boolean | null;
  updatePrompt?: boolean | null;
};
export type CodeAnswerInput = {
  marks: ReadonlyArray<MarkInput>;
  text?: string | null;
};
export type MarkInput = {
  from: SrclocInput;
  options: MarkOptionsInput;
  to: SrclocInput;
};
export type SrclocInput = {
  ch: number;
  line: number;
  sticky?: string | null;
};
export type MarkOptionsInput = {
  inclusiveLeft?: boolean | null;
  inclusiveRight?: boolean | null;
};
export type CodeInitialFile = {
  file: string;
};
export type HtmlInput = {
  type: HtmlTag;
  value: string;
};
export type CodeChangeMutation$variables = {
  input: ChangeCodeDetailsInput;
};
export type CodeChangeMutation$data = {
  readonly changeCodeDetails: {
    readonly bodyItem: {
      readonly answer: any | null;
      readonly id: string;
      readonly info: any;
    };
  } | null;
};
export type CodeChangeMutation = {
  response: CodeChangeMutation$data;
  variables: CodeChangeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ChangeCodeDetailsPayload",
    "kind": "LinkedField",
    "name": "changeCodeDetails",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BodyItem",
        "kind": "LinkedField",
        "name": "bodyItem",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "info",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "answer",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CodeChangeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CodeChangeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "fb7d2c4c3070d2398cb824d31c805be8",
    "metadata": {},
    "name": "CodeChangeMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "cd748ca6ffb13a2b374da18f4dd24d3d";

export default node;
